var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share",on:{"click":function($event){return _vm.share()}}},[_c('span',{staticClass:"label"},[_vm._v("\n\t\tDel\n\t\t"),_c('i',{key:"on",staticClass:"fab fa-facebook-square fa-fw"})])])}
var staticRenderFns = []

export { render, staticRenderFns }